import {takeEvery} from 'redux-saga/effects'

import {
  ADMISSION_LOGIN,
  CHECK_INSTANCES,
  LOGIN_USER,
  LOGIN_USER_JWT,
  LOGIN_WITH_GOOGLE,
  LOGOUT_USER,
  UNIVERSAL_LOGIN,
  UNIVERSAL_LOGIN_WITH_GOOGLE,
  USER_ME,
  VERIFY_LOGIN_CREDENTIALS,
} from '../../Actions/SignIn/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(LOGIN_USER, fetchData)
  yield takeEvery(LOGIN_USER_JWT, fetchData)
  yield takeEvery(LOGOUT_USER, fetchData)
  yield takeEvery(USER_ME, fetchData)
  yield takeEvery(VERIFY_LOGIN_CREDENTIALS, fetchData)
  yield takeEvery(ADMISSION_LOGIN, fetchData)
  yield takeEvery(LOGIN_WITH_GOOGLE, fetchData)
  yield takeEvery(UNIVERSAL_LOGIN, fetchData)
  yield takeEvery(UNIVERSAL_LOGIN_WITH_GOOGLE, fetchData)
  yield takeEvery(CHECK_INSTANCES, fetchData)
}

export default dataSaga
